import ErrorFallback from 'components/core/ErrorFallback';
import { Spinner } from 'react-bootstrap';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import Routes from './routes';
import customHistory from './services/history';

import 'react-toastify/dist/ReactToastify.css';

const persistLoadingFallback = (
  <div className="d-flex justify-content-center align-items-center min-vh-100">
    <Spinner animation="border" variant="primary" role="status">
      <span className="visually-hidden">Carregando...</span>
    </Spinner>
  </div>
);

function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, errorInfo) => {
        console.error('ErrorBoundary capturou um erro:', error, errorInfo);
      }}
    >
      <Provider store={store}>
        <PersistGate loading={persistLoadingFallback} persistor={persistor}>
          <Router history={customHistory}>
            <Routes />
            <ToastContainer
              position="top-center"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Router>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
